import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "flex items-center p-2 px-3 bg-gray-200 dark:bg-gray-800 rounded-lg" }
const _hoisted_2 = ["src", "alt"]
const _hoisted_3 = { class: "titleFont text-2xl mx-3 text-gray-700 dark:text-white" }
const _hoisted_4 = { class: "md:pl-14 mt-2" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_6 = /*#__PURE__*/_createElementVNode("span", { class: "appFont text-gray-600 dark:text-gray-300" }, "Website: ", -1)
const _hoisted_7 = ["href"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Tippy = _resolveComponent("Tippy")!
  const _component_Sheet = _resolveComponent("Sheet")!

  return (_openBlock(), _createBlock(_component_Sheet, {
    onClose: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('close'))),
    visibility: _ctx.showSheet
  }, {
    default: _withCtx(() => [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.tags, (tag) => {
        return (_openBlock(), _createElementBlock("div", {
          key: tag.name,
          class: "transition duration-150 border-b border-gray-200 dark:border-gray-700 py-2 px-5 last:border-none hover:bg-gray-200 dark:hover:bg-gray-800"
        }, [
          _createElementVNode("div", _hoisted_1, [
            _createElementVNode("img", {
              src: tag.image,
              alt: `${tag.name}'s image`,
              class: "w-[45px] rounded-full"
            }, null, 8, _hoisted_2),
            _createElementVNode("h3", _hoisted_3, _toDisplayString(tag.name), 1),
            _createElementVNode("div", {
              class: _normalizeClass(["ml-auto text-white px-4 py-1 rounded-lg cursor-pointer bg-gray-400 appFont noselect", {'!bg-primary-300 dark:!bg-primary-400': tag.role == 'owner'}])
            }, [
              _createVNode(_component_Tippy, {
                content: `${tag.role.capitalize()} Badge`
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(tag.role.capitalize()), 1)
                ]),
                _: 2
              }, 1032, ["content"])
            ], 2)
          ]),
          _createElementVNode("p", _hoisted_4, [
            _createTextVNode(_toDisplayString(tag.description) + " ", 1),
            (tag.website)
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                  _hoisted_5,
                  _hoisted_6,
                  _createElementVNode("a", {
                    href: tag.website,
                    class: "text-primary-400 appFont",
                    target: "_blank"
                  }, _toDisplayString(tag.website), 9, _hoisted_7)
                ], 64))
              : _createCommentVNode("", true)
          ])
        ]))
      }), 128))
    ]),
    _: 1
  }, 8, ["visibility"]))
}